module.exports = __webpack_public_path__ + "static/media/bg-calltoaction.c3f28b6e.png";